import AppBar from './AppBar'
import enhance from './AppBar.enhancer'

export default enhance(AppBar)



// WEBPACK FOOTER //
// ./src/App/components/AppBar/index.js